import React, { FC, useEffect } from "react";
import { ONE_SIZE } from "@/constants";
import ProductSizeItem from "./productSizeItem";
import { ProductVariant } from "@/routes/pdp/types";
import { ProductSizeListProps } from "./types";

const ProductSizeList: FC<ProductSizeListProps> = ({
  selectedSize,
  productSizes,
  onSizeSelection
}) => {
  useEffect(() => {
    const firstSize = productSizes[0]?.size;
    const selectedSizeValue = selectedSize.size?.size;

    if (firstSize === ONE_SIZE && selectedSizeValue !== ONE_SIZE) {
      onSizeSelection(productSizes[0] as ProductVariant);
    }
  }, [productSizes, onSizeSelection, selectedSize.size]);

  if (!productSizes.length) return null;

  return (
    <ul
      className="size_list position-relative"
      onClick={e => e.preventDefault()}
    >
      {productSizes.map(size => (
        <ProductSizeItem
          key={size.sizeId}
          size={size}
          selectedSize={selectedSize}
          onSizeSelection={onSizeSelection}
        />
      ))}
    </ul>
  );
};

export default ProductSizeList;
